import React, { useEffect } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { useDispatch } from 'react-redux';
import { jwtDecode } from "jwt-decode";
import { format, intervalToDuration } from 'date-fns';
import { logoutUser } from './Reducers/authActions'; // Import your logoutUser action
import { store } from './index'; // Import store (redux)


const AuthObserver = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    checkTokenExpiration();

    // Set up an interval to periodically check and refresh the token (e.g., every 5 minutes)
    const tokenCheckInterval = setInterval(() => {
      checkTokenExpiration();
    }, 5 * 60 * 1000); // every 5 minutes

    // Clear the interval when the component is unmounted

    return () => clearInterval(tokenCheckInterval);

  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const checkTokenExpiration = async () => {
    const currentTimestamp = Math.floor(Date.now() / 1000);
    var userToken = props.Login.userToken;
    if (props.Login !== null && props.Login !== undefined) {
      const tokenExpiration = jwtDecode(userToken).exp;
      var diff = (tokenExpiration - currentTimestamp) * 1000;
      const duration = intervalToDuration({ start: 0, end: diff });
      const hours = duration !== null && duration !== undefined && duration.hours !== null && duration.hours !== undefined ? duration.hours.toString().padStart(2, '0') : "0";
      const minutes = duration !== null && duration !== undefined && duration.hours !== null && duration.minutes !== undefined ? duration.minutes.toString().padStart(2, '0') : "0";
      const seconds = duration !== null && duration !== undefined && duration.hours !== null && duration.seconds !== undefined ? duration.seconds.toString().padStart(2, '0') : "0";
      var formattedDuration = hours + ':' + minutes + ':' + seconds;

      console.log(format(new Date(), 'HH:mm:ss'), ' --> tokenExpiration ', tokenExpiration, ' - currentTimestamp ', currentTimestamp, '(Token expires in: ' + formattedDuration + ' )');

      //Check if the token expires in 6 minutes --> If so refresh
      if (!userToken || tokenExpiration < currentTimestamp + 360) {
        await dispatch(refreshToken());
      }
    }

  };


  const refreshToken = () => async (dispatch, getState) => {
    try {
      const user = firebase.auth().currentUser;

      if (user) {
        const newToken = await user.getIdToken(/* forceRefresh */ true);
        props.actions.setUserToken(newToken);
        return newToken;
      } else {
        // Handle the case when the user is not authenticated
        if (!window.location.pathname.toLocaleLowerCase().includes('login') && !window.location.pathname.toLocaleLowerCase().includes('/measure')) {
          // User is signed out
          // logout();
          store.dispatch(logoutUser());

        } return null;
      }
    } catch (error) {
      console.error('Error refreshing token:', error);
      // Handle the error, maybe logout the user
      if (!window.location.pathname.toLocaleLowerCase().includes('login') && !window.location.pathname.toLocaleLowerCase().includes('/measure')) {
        // User is signed out
        // logout();
        store.dispatch(logoutUser());

      }
      return null;
    }
  };

  return (
    <React.Fragment>
      {/* {console.log('FireBase-User Logged In: ', firebase.auth().currentUser !== null && firebase.auth().currentUser !== undefined)} */}
    </React.Fragment>
  );
};

export default AuthObserver;